import React from "react";
import classNames from "classnames";
import { useAppSelector } from "hooks/redux";
import {
  generateSelectDesignStyles,
  IWebsiteBuilderSelect,
} from "pages/secure/facility/websiteBuilder/editor/nodes/element/websiteBuilderSelect";

interface IWebsiteBuilderSelectViewProps {
  node: IWebsiteBuilderSelect;
}

export function WebsiteBuilderSelectView(props: IWebsiteBuilderSelectViewProps) {
  const { node } = props;

  const selectedNodeId = useAppSelector(store => store.websiteBuilderStore.selectedNode?.id);
  const selected = selectedNodeId === node.id;

  const settings = node.element.settings;
  const designStyles = generateSelectDesignStyles();

  return (
    <label
      className={classNames(designStyles.labelClassName, "element-content", {
        "element-content-selected": selected,
      })}
    >
      <div
        className={classNames(designStyles.labelContentClassName, "element-content", {
          "element-content-selected": selected,
        })}
      >
        {settings.label}
      </div>
      <select
        className={classNames(designStyles.className, "element-content", {
          "element-content-selected": selected,
        })}
        onPointerDown={e => e.preventDefault()}
      />
    </label>
  );
}
